<template>
    <div class="landing-view">
        <div class="center-element">
            <!-- <v-handje></v-handje> -->

            <div class="copy">
                <h2>Schud <span class="gold"><i>zooo</i> veel money</span> <br />uit de boom en maak <br/>gratis kans op</h2>
                <h1>
                    <div class="star-wrapper">
                        <img class="star star-1" src="/static/img/flare.png"/>
                        <img class="star star-2" src="/static/img/star.png"/>
                    </div>
                    <span class="gold">&euro;20.000</span>
                </h1>
            </div>

            <img class="geldboom" src="/static/img/geldmeneer.png" />

            <button class="ejp-btn pulse" @click="onContinue">Doe mee</button>
        </div>
    </div>
</template>

<style lang="scss">
.landing-view{
    .cloche{
    }
}
</style>

<script>
    /* eslint-disable */
    import { TweenMax } from '@/vendor';
    import { starAnim } from '@/app/mixins';

    export default {
        name: 'Landing',

        mixins: [ starAnim ],

        data()
        {
            return {
                handOpen: true
            };
        },

        mounted()
        {
        },

        methods: {
            onContinue()
            {
                if( window.DeviceMotionEvent )
                {
                    if( typeof window.DeviceMotionEvent.requestPermission === 'function')
                    {
                        window.DeviceMotionEvent.requestPermission()
                        .then(permissionState => {
                            if (permissionState === 'granted')
                            {
                                // DeviceMotionEvent.requestPermission() has been granted
                            }
                        })
                        .catch( console.error );
                    }
                }

                this.$router.push( '/game' );
            },

            getAnimateIn()
            {
                // TweenMax.set( '.copy', { transformOrigin: '50% 100%' });
                let tl = new TimelineMax({ });
                /*
                tl.add( 'start', 0.5 );
                //tl.add( 'frame1', 'start+=1' );
                tl.add( 'frame1', 'start+=1.4' );
                tl.add( 'frame2', 'frame1+=1' );

                tl.from(['.cloche', '.copy', '.dienblad'], 0.5, { y: window.innerHeight, ease: Sine.easeOut }, 'start' );
                // tl.addPause( 'frame1+=0.5' );

                tl.add( () =>
                {
                    this.handOpen = false;
                }, 'start+=1.1' );

                tl.fromTo( '.handje', 0.1, { opacity: 0 }, { opacity: 1 }, 'start+=0.25' );
                tl.from( '.handje', 1.5, { x: 500, y: -500, ease: Power3.easeOut }, 'start' );

                tl.from( '.copy', 0.4, { scale: 0.5, ease: Back.easeOut }, 'frame1' );
                tl.to( '.cloche', 0.4, { y: -300, x: 100, rotation: 30 }, 'frame1' ) ;
                tl.to( '.handje', 0.4, { y: -285, x: 85, rotation: 30 }, 'frame1' ) ;

                tl.staggerTo( '.gold', 0.3, { scale: 1.3, yoyo: true, repeat: 1 }, 0.2, 'frame2' );

                tl.add(  this.starTwinkle, 'frame2+=0.5' );

                tl.fromTo( '.ejp-btn', 0.4, { x: '-50%', scale: 1, backgroundColor: '#1d9dd9' }, { scale: 1.1, backgroundColor: '#59c3f5', yoyo: true, repeat: 1 }, 'frame1+=2' );
                tl.fromTo( '.ejp-btn', 0.4, { x: '-50%', scale: 1, backgroundColor: '#1d9dd9' }, { scale: 1.1, backgroundColor: '#59c3f5', yoyo: true, repeat: 1 }, 'frame1+=3' );
                tl.fromTo( '.ejp-btn', 0.4, { x: '-50%', scale: 1, backgroundColor: '#1d9dd9' }, { scale: 1.1, backgroundColor: '#59c3f5', yoyo: true, repeat: 1 }, 'frame1+=4' );
                */
                return tl;
            },

            getAnimateOut()
            {
                let tl = new TimelineMax();

                tl.to( '.center-element', 0.5, { opacity: 0 });

                return tl;
            }
        }
    };
</script>
